module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/knowledgeresources.json
// module id = 1440
// module chunks = 255816951464858